import { render, staticRenderFns } from "./XXXTab.vue?vue&type=template&id=c7760e94&scoped=true"
import script from "./XXXTab.vue?vue&type=script&lang=js"
export * from "./XXXTab.vue?vue&type=script&lang=js"
import style0 from "./XXXTab.vue?vue&type=style&index=0&id=c7760e94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7760e94",
  null
  
)

export default component.exports